import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import dynamic from 'next/dynamic'

import Button from 'components/buttons/button'
import { TYPOGRAPHY_15_12 } from 'theme/theme'
const Loader = dynamic(() => import('components/utils/loaders/inline'), { ssr: false })

const Text = styled.div`
  ${TYPOGRAPHY_15_12}

  color: ${props => props.primary ? '#fff' : '#0bf'};
  margin: auto;
  white-space: nowrap;
`

function Submit ({ name, loading, onClick, variant, maxW, minW }) {
  return (
    <>
      { onClick
        ? <Button onClick={onClick} data-test="submit" maxW={maxW} minW={minW} primary>
            { loading ? <div><Loader white /></div> : <Text primary>{ name }</Text> }
          </Button>
        : <Button type="submit" variant={variant} data-test="submit" minW={minW} maxW={maxW} primary>
            { loading ? <div><Loader white /></div>
              : <Text primary>{ name }</Text> }
          </Button> }
    </>
  )
}

export default memo(Submit)

Submit.propTypes = {
  name: PropTypes.string,
  maxW: PropTypes.string,
  minW: PropTypes.string,
  loading: PropTypes.bool,
  variant: PropTypes.any,
  primary: PropTypes.bool,
  onClick: PropTypes.any
}
